<template>
    <div class="row mb-5 mt-3">
      <div class="col-md-8">
        <h2>Koledar</h2>
      </div>
    </div>

    <div class="row mb-2 filter-customer-entity">
      <div class="col-md-4">
        <SelectCustomerEntity
          col-class-left="col-sm-3"
          col-class-right="col-sm-9"
          :customerID="filters.customer"
          :facilityID="filters.facility"
          :canChange="true"
          @change="e => { filters.customer = e.customerID;  filters.facility = e.facilityID }"
        />
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-8">
        <div class="row">
          <label class="col-form-label col-sm-3">Datum od</label>
          <div class="col-sm-9">
            <input type="date" class="form-control" v-model="filters.dateFrom" />
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-8">
        <div class="row">
          <label class="col-form-label col-sm-3">Datum do</label>
          <div class="col-sm-9">
            <input type="date" class="form-control" v-model="filters.dateTo" />
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <a class="btn btn-secondary" @click="resetFilters">Pobriši iskalne pogoje</a>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <div class="table-responsive">
          <table class="table table-striped table-sm table-hover">
            <thead>
              <tr>
                <th scope="col">Datum in ura dogodka</th>
                <th scope="col">Servisni nalog ali periodika</th>
                <th scope="col">Stranka</th>
                <th scope="col">Objekt</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!events.length">
                <td colspan="4" class="text-center text-muted">Ni rezultatov</td>
              </tr>
              <tr role="button" v-for="event in events" :key="event.id">
                <td @click="selectEvent(event, true)" class="bg-light">{{ $dayjs(event.dateTime).format($DATE_FORMAT_DISPLAY) }}</td>
                <td @click="selectEvent(event, true)" class="bg-light">{{ event.orderNumber }} {{ event.servicesDue }}</td>
                <td @click="selectEvent(event)">{{ event.customer }}</td>
                <td @click="selectEvent(event)">{{ event.facility }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <Paging v-if="events?.length" :paging="paging" @change="setPageNum" />
</template>

<script setup>
/* global VueRouter */
import { ref, toRef, toRefs, computed, defineComponent, watch, reactive, onMounted, inject } from "vue"
import { EMPTY_GUID } from "../utils/constants"
import { useCalendar } from "../composition-api/useCalendar"

defineOptions({ name: "Calendar" })

const router = VueRouter.useRouter()

const { paging, resetPaging, setPageNum, filters, events, resetFilters } = useCalendar(undefined, {
  syncQueryParams: true,
})

const selectEvent = (event, openInNewWindow = false) => {
  let routeData = null
  if (event.serviceOrderId !== EMPTY_GUID) {
    routeData = router.resolve({ name: "ServiceOrder", params: { workOrderId: event.serviceOrderId } })
  } else if (event.deviceId !== EMPTY_GUID) {
    routeData = router.resolve({ name: "DeviceEdit", params: { deviceId: event.deviceId } })
  }
  if (openInNewWindow) {
    window.open(routeData.href, "_blank")
  } else {
    router.push(routeData)
  }
}
</script>
